import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from "./pages/_Layout";
import VisitUsPage from './pages/VisitUsPage';
import NoPage from "./pages/NoPage";
import DonationPage from "./pages/DonationPage";
import TeamPage from "./pages/TeamPage";
import AboutPage from "./pages/AboutPage";
import ActivityPage from "./pages/ActivityPage";
import TSAEvent from "./pages/events/TSAEvent";
import EvDislexieEvent from "./pages/events/EvDislexieEvent";
import Neurodiversity from "./pages/articles/Neurodiversity";
import RecoverTherapy from "./pages/articles/RecoverTherapy";
import Logopedy from "./pages/articles/Logopedy";
import PsychologyVsPsychiatry from "./pages/articles/PsychologyVsPsychiatry";
import AutismDayEvent from "./pages/events/AutismDayEvent";
import AutismDay2026 from "./pages/events/AutismDay2026";
import WorkshopEvent from "./pages/events/WorkshopEvent";
import TherapeuticCamp from "./pages/events/TherapeuticCamp";
import ArtTherapyWorkshop from "./pages/events/ArtTherapyWorkshop";
import RetreatEvent from "./pages/events/RetreatEvent";
import CampRetrospective from "./pages/events/CampRetrospective";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<AboutPage />} />
          <Route path="/activity" element={<ActivityPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/visitus" element={<VisitUsPage />} />
          <Route path="/donation" element={<DonationPage />} />
          <Route path="/events/retreatevent" element={<RetreatEvent />} />
          <Route path="/events/arttherapyevent" element={<ArtTherapyWorkshop />} />
          <Route path="/events/therapeuticcamp" element={<TherapeuticCamp />} />
          <Route path="/events/camp_retrospective" element={<CampRetrospective />} />
          <Route path="/events/workshopevent" element={<WorkshopEvent />} />
          <Route path="/events/autismdayevent" element={<AutismDayEvent />} />
          <Route path="/events/autismday2026" element={<AutismDay2026 />} />
          <Route path="/events/tsaevent" element={<TSAEvent />} />
          <Route path="/events/evdislexieevent" element={<EvDislexieEvent />} />
          <Route path="/articles/neurodiversityarticle" element={<Neurodiversity />} />
          <Route path="/articles/recovertherapyarticle" element={<RecoverTherapy />} />
          <Route path="/articles/logopedyarticle" element={<Logopedy />} />
          <Route path="/articles/psychologypsychiatryarticle" element={<PsychologyVsPsychiatry />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

